// Shared CTA component for buttons. Links (using href) should use WebLink.js instead.
// Centralizes colors, hover styles, and disabled states to prevent styling drift (BL-603).
// Size and layout stay with the caller via `className`.
const VARIANTS = {
  solid: 'bg-sea text-white hover:bg-sea-dark disabled:hover:bg-sea',
  invert:
    'border-2 border-sea bg-sea text-white hover:bg-transparent hover:text-sea disabled:hover:bg-sea disabled:hover:text-white',
  outline:
    'border-2 border-sea text-sea hover:bg-sea hover:text-white disabled:hover:bg-transparent disabled:hover:text-sea',
};

const CTAButton = ({
  variant = 'solid',
  disabled = false,
  type = 'button',
  icon = null,
  className = '',
  radius = 'rounded-full',
  children,
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 ${radius} font-medium transition-colors ease-in-out duration-200 ${VARIANTS[variant] ?? VARIANTS.solid} ${
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
      } ${className}`}
      {...props}
    >
      {icon}
      {children}
    </button>
  );
};

export default CTAButton;
